import Layout from './components/Layout';

import GlobalStyles from './styles/GlobalStyles';

function App() {
  return (
    <>
    <GlobalStyles />
    <Layout />
    </>
  );
}

export default App;
